// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-navigation-create-entry__button-create_with-menu .g-button__text {
  padding-left: 10px;
}
.dl-navigation-create-entry__button-create_action {
  min-width: 150px;
}
.dl-navigation-create-entry__item-title {
  height: 32px;
  display: flex;
  align-items: center;
  padding: 0 6px;
}
.dl-navigation-create-entry__icon-connection {
  color: var(--g-color-text-utility);
}
.dl-navigation-create-entry__popup-menu {
  min-width: 144px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/Navigation/Core/CreateEntry/CreateEntry.scss"],"names":[],"mappings":"AAGY;EACI,kBAAA;AAFhB;AAMQ;EACI,gBAAA;AAJZ;AAQI;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AANR;AASI;EACI,kCAAA;AAPR;AAUI;EACI,gBAAA;AARR","sourcesContent":[".dl-navigation-create-entry__button-create_with-menu .g-button__text {\n  padding-left: 10px;\n}\n.dl-navigation-create-entry__button-create_action {\n  min-width: 150px;\n}\n.dl-navigation-create-entry__item-title {\n  height: 32px;\n  display: flex;\n  align-items: center;\n  padding: 0 6px;\n}\n.dl-navigation-create-entry__icon-connection {\n  color: var(--g-color-text-utility);\n}\n.dl-navigation-create-entry__popup-menu {\n  min-width: 144px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
